// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pl_a bhm_ea bhm_ke bhm_ju bhm_a bhm_j bhm_so bhm_sp","SearchPanel__icon":"pl_b bhm_vo bhm_hi bhm_su bhm_va","SearchPanel__input":"pl_c bhm_jb bhm_eg bhm_z"};